import { useTranslation } from "react-i18next";
import LegalDocView from "@/components/legal/LegalDocView";
import { getBiometricDoc } from "@/content/legal";
import { faceDataPolicyHref, getFaceDataPolicyCopy } from "@/content/faceDataPolicy";

/**
 * Public "Biometric data retention policy" at /biometric-data-retention (linked from the
 * 20 October 2026 announcement, the pricing-changes page, the privacy policy §4 and the footer).
 * Content: src/content/legal/biometric.<lang>.ts (English master and fallback).
 */
const BiometricRetentionPolicy = () => {
  const { i18n } = useTranslation();
  const doc = getBiometricDoc(i18n.language);
  // English page: its "see also" link stays English too (the face data policy's Studio tab).
  const { seeAlso } = getFaceDataPolicyCopy("en");
  return (
    <LegalDocView
      doc={doc}
      seeAlso={{ ...seeAlso, href: faceDataPolicyHref("studio") }}
      seo={{
        title: `${doc.title} | Photohawk`,
        description:
          "How long Photohawk keeps face-search data and when it is deleted: no later than 12 months after a photo is uploaded, within 30 days of a gallery closing or a deletion request. Selfies are never stored.",
      }}
    />
  );
};

export default BiometricRetentionPolicy;
